import { Action } from 'redux';
import { cloneDeep } from 'lodash';
// Import States.
import {
	AppState,
	getInitialClaimState
} from '@app/redux/states';
// Import Actions.
import {
	SetClaimAction,
	SetPreviousClaimsAction,
	LoadPreviousClaimsAction,
	LoadClaimPerilsAction,
} from '@app/redux/actions';
// Import api models.
import {
	Peril,
	PolicyLoss
} from '@app/models/api';

/**
 * This handles initializing the state.
 * @param state
 */
let initializeState = (state: AppState): AppState => {
	let newState: AppState = { ...state };

	if (!newState.claim) {
		newState.claim = getInitialClaimState();
	} else {
		newState.claim = cloneDeep(newState.claim);
	}
	return newState;
}

// Set New Claim Reducer.

let SetNewClaimReducer = (state: AppState, action: Action): AppState => {
	let setClaimAction: SetClaimAction = action as SetClaimAction;
	let newClaim: PolicyLoss = setClaimAction.claim;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.claim.currentClaim = newClaim;

	return newState;
}

// Set Previous Claims Reducer.

let SetPreviousClaimsReducer = (state: AppState, action: Action): AppState => {
	let setPreviousClaimsAction: SetPreviousClaimsAction = action as SetPreviousClaimsAction;
	let previousClaims: PolicyLoss[] = setPreviousClaimsAction.previousClaims;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.claim.previousClaims = previousClaims;

	return newState;
}

// Load Claim Perils Reducer.

let LoadClaimPerilsReducer = (state: AppState, action: Action): AppState => {
	let loadClaimPerilsAction: LoadClaimPerilsAction = action as LoadClaimPerilsAction;
	let perils: Peril[] = loadClaimPerilsAction.claimPerils;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.claim.perils = perils;

	return newState;
}

// Load Previous Claims Reducer.

let LoadPreviousClaimsReducer = (state: AppState, action: Action): AppState => {
	let loadPreviousClaimsAction: LoadPreviousClaimsAction = action as LoadPreviousClaimsAction;
	let previousClaims: PolicyLoss[] = loadPreviousClaimsAction.previousClaims;

	// Create copy of the of app state.
	let newState: AppState = initializeState(state);

	newState.claim.previousClaims = previousClaims;

	return newState;
}

// Export reducers.
export {
	LoadClaimPerilsReducer,
	LoadPreviousClaimsReducer,
	SetNewClaimReducer,
	SetPreviousClaimsReducer
};